export const BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/api`;
export const BASE_URL_V2 = `${import.meta.env.VITE_API_BASE_URL}/api/v2`;
export const AUQLI_STORE_BASE_URL = `${import.meta.env.VITE_AUQLI_STORE_BASE_URL}`;
